


export function TargetAchieversGroups() {
  return (
    <div className="bg-card rounded-lg border border-border p-6">
      <h2 className="text-xl font-bold text-foreground mb-6">Target Achievers Groups</h2>
      
      <div>Table for Target Achievers</div>
      <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left py-3 px-4 text-sm font-semibold text-muted-foreground">NAME</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-muted-foreground">MOBILE</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-muted-foreground">SALARY</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-muted-foreground">GROUPCODE</th>
              <th className="text-left py-3 px-4 text-sm font-semibold text-muted-foreground">CREATEDAT</th>
            </tr>
          </thead>
          
        </table>
    </div>
  )
} 


